/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ remaining: NonNullable<unknown>, daysLeft: NonNullable<unknown> }} Insight_Consistency_BehindInputs */

const en_us2_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`One workout left to close the week. There is still time.`);
	return /** @type {LocalizedString} */ (`${i?.remaining} workouts left to close the week. There is still time.`)
	
};

const pt_br2_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`Falta 1 treino para fechar a semana. Ainda dá tempo.`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.remaining} treinos para fechar a semana. Ainda dá tempo.`)
	
};

const es_419_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`Te falta un entrenamiento para cerrar la semana. Aún hay tiempo.`);
	return /** @type {LocalizedString} */ (`Te faltan ${i?.remaining} entrenamientos para cerrar la semana. Aún hay tiempo.`)
	
};

const pt_pt2_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`Falta 1 treino para fechar a semana. Ainda vais a tempo.`);
	return /** @type {LocalizedString} */ (`Faltam ${i?.remaining} treinos para fechar a semana. Ainda vais a tempo.`)
	
};

const fr_fr2_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`Encore une séance pour boucler la semaine. Il est encore temps.`);
	return /** @type {LocalizedString} */ (`Encore ${i?.remaining} séances pour boucler la semaine. Il est encore temps.`)
	
};

const de_de2_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`Noch ein Training, um die Woche abzuschließen. Es ist noch Zeit.`);
	return /** @type {LocalizedString} */ (`Noch ${i?.remaining} Trainings, um die Woche abzuschließen. Es ist noch Zeit.`)
	
};

const it_it2_insight_consistency_behind = /** @type {(inputs: Insight_Consistency_BehindInputs) => LocalizedString} */ (i) => {
	if ((i?.remaining === 1 || i?.remaining === "1")) return /** @type {LocalizedString} */ (`Manca un allenamento per chiudere la settimana. C'è ancora tempo.`);
	return /** @type {LocalizedString} */ (`Mancano ${i?.remaining} allenamenti per chiudere la settimana. C'è ancora tempo.`)
	
};

/**
* | remaining | output |
* | --- | --- |
* | "1" | "One workout left to close the week. There is still time." |
* | * | "{remaining} workouts left to close the week. There is still time." |
*
* @param {Insight_Consistency_BehindInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const insight_consistency_behind = /** @type {((inputs: Insight_Consistency_BehindInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Insight_Consistency_BehindInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_insight_consistency_behind(inputs)
	if (locale === "es-419") return es_419_insight_consistency_behind(inputs)
	if (locale === "pt-PT") return pt_pt2_insight_consistency_behind(inputs)
	if (locale === "fr-FR") return fr_fr2_insight_consistency_behind(inputs)
	if (locale === "de-DE") return de_de2_insight_consistency_behind(inputs)
	if (locale === "it-IT") return it_it2_insight_consistency_behind(inputs)
	return en_us2_insight_consistency_behind(inputs)
});
export { insight_consistency_behind as "insight.consistency_behind" }